<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="date"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        prepend-icon="event"
        readonly
        v-on="on"
      />
    </template>
    <v-date-picker
      ref="picker"
      v-model="date"
      no-title
      scrollable
      reactive
      @input="save"
    >
      <v-spacer />
      <!-- <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
      <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>-->
    </v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    name: "PsDatepicker",
    props: {
      dateType: {
        type: String,
        required: true
      },
      value: null,
      outline: {
        type: Boolean,
        required: true
      },
      dense: {
        type: Boolean,
        required: true
      },
      solo: {
        type: Boolean,
        required: true
      },
      items: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        date: new Date().toISOString().substr(0, 4), // to do: allow user to specify format. This ends up being yyyy-mm, which is not relevant when selecting a yyyy-mm-dd date from the picker.
        // date: this.date, // to do: allow user to specify format. This ends up being yyyy-mm, which is not relevant when selecting a yyyy-mm-dd date from the picker.
        menu: false,
        modal: false
      };
    },
    watch: {
        menu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
        },
        date (val) {
            this.$emit("date-event", val);
        }
    },
    mounted () {

    },
    methods: {
      save (date) {
        this.$refs.menu.save(date.substr(0, 4));
        this.$refs.picker.activePicker = "YEAR";
        this.menu = false;
      }
    }
  };
</script>
